
import { defineComponent } from 'vue'
import { useHelpBody } from '@/views/help/use-help-body'
import { downloadByUrl } from '@/utils/tool'

export default defineComponent({
  setup () {
    function downloadPsFile () {
      downloadByUrl('https://dubaee.obs.cn-north-4.myhuaweicloud.com/dubaee/file/%E9%9A%90%E6%80%A7%E6%B0%B4%E5%8D%B0%E6%9F%A5%E7%9C%8B%E6%96%87%E4%BB%B6.psd')
    }

    useHelpBody()
    return {
      downloadByUrl,
      downloadPsFile,
    }
  }
})
